import * as Yup from 'yup';

export const addSalesInvoiceValidation = Yup.object().shape({
    invoiceTo: Yup.string().required('Invoice to is required'),
    partner: Yup.object()
        .shape({
            key: Yup.string(),
            value: Yup.string(),
        })
        .nullable()
        .when('invoiceTo', (invoiceTo, validationSchema) => {
            if (invoiceTo === 'PARTNER') {
                return validationSchema.required('Partner is required');
            }
            return validationSchema;
        }),
    merchant: Yup.object()
        .shape({
            key: Yup.string(),
            value: Yup.string(),
        })
        .nullable()
        .when('invoiceTo', (invoiceTo, validationSchema) => {
            if (invoiceTo === 'MERCHANT') {
                return validationSchema.required('Merchant is required');
            }
            return validationSchema;
        }),
    billingCycle: Yup.string()
        .required('Billing cycle is required')
        .typeError('Biling cycle is required'),
    invoiceOccurrence: Yup.string()
        .optional()
        .when('billingCycle', {
            is: 'RECURRING',
            then: Yup.string()
                .required('Invoice Occurrence is required')
                .typeError('Invoice Occurrence is required'),
            otherwise: Yup.string().optional().nullable().notRequired(),
        }),
    invoiceFrequency: Yup.object().when('billingCycle', {
        is: 'RECURRING',
        then: Yup.object({
            key: Yup.string(),
            value: Yup.string(),
        })

            .required('Invoice frequency is required')
            .typeError('Invoice frequency is required'),
        otherwise: Yup.object().optional().notRequired(),
    }),
    occurrenceType: Yup.string()
        .nullable()
        .when('billingCycle', {
            is: 'RECURRING',
            then: Yup.string()
                .required('Occurrence Type is required')
                .typeError('Occurrence Type is required'),
            otherwise: Yup.string().optional().nullable().notRequired(),
        }),
    numberOfInvoices: Yup.number()
        .optional()
        .when('occurrenceType', {
            is: 'FIXED_OCCURRENCE',
            then: Yup.number()
                .required('Number of invoices is required')
                .typeError('Number of invoices is required'),
            otherwise: Yup.number().optional().nullable().notRequired(),
        }),
});
